import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'

class Chat extends Component {
  componentDidMount() {
    this.init()
  }

  init() {
    const {chatbiUrl, chatbiEmbeddedId} = window.g
    const script = document.createElement('script');
    script.defer = true;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `${chatbiUrl}/static/chatbi-embedded-dynamic.umd.js`;
    document.head.appendChild(script);
    let chatbi_embedded_timer = setInterval(() => {
      if (window.chatbi_embedded_handler?.mounted) {
        window.chatbi_embedded_handler.mounted('.copilot', {
          embeddedId: chatbiEmbeddedId,
          domain_url: chatbiUrl
        })
        clearInterval(chatbi_embedded_timer)
      }
    }, 1000)
  }

  render() {
    return (
      <div className="full-page copilot" style={{height: '90vh'}}/>
    )
  }
}

export default withTranslation()(Chat)
